import { getLogger } from '../../base/logging/functions';
export default getLogger('features/stream-effects/noise-suppression');
